import type { Timestamp } from 'firebase/firestore';
import i18n from '../../lib/i18n';
import { toEpochSeconds } from './epoch';

// Server (UTC on Vercel) and browser must print the same calendar day, so every legacy
// helper formats in the platform time zone and the active UI language.
export const PLATFORM_TIME_ZONE = 'Europe/Istanbul';
const LOCALES: Record<string, string> = { tr: 'tr-TR', en: 'en-GB', ru: 'ru-RU' };

const formatters = new Map<string, Intl.DateTimeFormat>();
const formatter = (kind: 'date' | 'time', language?: string) => {
  const locale = LOCALES[(language || i18n.language || 'tr').slice(0, 2)] || LOCALES.tr;
  const key = `${kind}:${locale}`;
  if (!formatters.has(key)) {
    formatters.set(key, new Intl.DateTimeFormat(locale, kind === 'date'
      ? { day: 'numeric', month: 'long', year: 'numeric', timeZone: PLATFORM_TIME_ZONE }
      : { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: PLATFORM_TIME_ZONE }));
  }
  return formatters.get(key)!;
};

export const getDate = (firebaseDate: number | Timestamp = 0, language?: string): string => {
  const seconds = toEpochSeconds(firebaseDate);
  if (seconds === null) return '';
  return formatter('date', language).format(new Date(seconds * 1000));
};

export const getHoursAndMinutes = (firebaseDate: number | Timestamp = 0, language?: string): string => {
  if (typeof firebaseDate !== 'number' || !firebaseDate) return '';
  return formatter('time', language).format(new Date(firebaseDate * 1000));
};

export const getFullTime = (firebaseDate: number | Timestamp = 0, language?: string): string => {
  if (typeof firebaseDate !== 'number' || !firebaseDate) return '';
  return `${getDate(firebaseDate, language)} - ${getHoursAndMinutes(firebaseDate, language)}`;
};
